<div class="relative w-full" (click)="handleFocusOnButton()">
  <button
    #button
    class="relative pl-2 ps-0.5 pe-9 min-h-[46px] max-h-[66px] overflow-auto flex items-center flex-wrap text-nowrap w-full border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300"
    [ngClass]="{
      'bg-gray-100': disabled,
      'outline-none ring-1 ring-primary': focus,
    }"
  >
    @if(withChips()){ @for (option of selectedOptions; track $index) {
    <ui-chip
      [label]="option.label"
      [icon]="option.icon"
      [removable]="true"
      (remove)="removeOption(option)"
      [disabled]="disabled"
    >
    </ui-chip>
    } }@else{
    <div class="whitespace-nowrap text-gray-800">
      {{ selectedLabels }}
    </div>
    }
    <input
      class="py-3 px-2 min-w-[18px] w-min rounded-lg order-1 text-sm outline-none border-none focus:ring-0 focus:border-none"
      [placeholder]="placeholder()"
      [formControl]="searchTerm"
      (focus)="openDropdown()"
      #searchInput
      [ngClass]="{ 'bg-gray-100': disabled }"
      (click)="focus = true"
    />
    <div
      class="absolute top-1/2 end-3 -translate-y-1/2"
      (click)="toggleDropdown($event)"
    >
      <svg
        class="shrink-0 size-3.5 text-gray-500"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m7 15 5 5 5-5"></path>
        <path d="m7 9 5-5 5 5"></path>
      </svg>
    </div>
  </button>
  <div
    [ngClass]="{
      block: dropdownVisible && !disabled,
      hidden: !dropdownVisible
    }"
    class="absolute mt-2 z-50 w-full max-h-72 p-1 space-y-0.5 bg-white border border-gray-200 rounded-lg overflow-hidden overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 top-full"
  >
    @for (option of filteredOptions; track $index) {

    <div
      class="py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100"
      (click)="selectOption($event, option)"
      [ngClass]="{
        'cursor-not-allowed': disabled,
        'cursor-pointer': !disabled
      }"
    >
      <div class="flex items-center">
        @if (option.icon){
        <div class="size-8 me-2">
          <img
            class="inline-block rounded-full"
            alt="option icon"
            [src]="option.icon"
          />
        </div>
        }
        <div>
          <div class="text-sm font-semibold text-gray-800">
            {{ option.label }}
          </div>
          @if (option.description){
          <div class="text-xs text-gray-500">
            {{ option.description }}
          </div>
          }
        </div>
        <div class="ms-auto">
          @if(option.selected){
          <span>
            <svg
              class="shrink-0 size-4 text-primary"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
              />
            </svg> </span
          >}
        </div>
      </div>
    </div>
    } @if (!filteredOptions.length){
    <div class="flex items-center p-4">
      <div>
        <div class="text-sm font-semibold text-gray-500">
          {{ this.searchTerm.value ? 'No results found' : 'No options' }}
        </div>
      </div>
    </div>
    }
  </div>
</div>
